import React from 'react';
import { ActionButton, Flex, View } from '@adobe/react-spectrum';
// import Icon from 'app/components/general/Icon';
import * as Sentry from '@sentry/react';
import { uuid4 } from '@sentry/utils';
import { LogoInHTML } from 'app/assets/brands/Logo';
import { Spectrum } from 'app/components/Spectrum';
/**
 * Crash browser page
 */
const Crash = ({ eventId }) => {
    // const { tp } = facade.gettext;
    const tp = (_s, english, ..._other) => english;
    const refreshPage = () => {
        window.location.reload();
    };
    const onReport = React.useCallback(() => {
        Sentry.showReportDialog({
            eventId: eventId || uuid4(),
            title: tp('ErrorFeedback', 'It looks like we’re having issues.'),
            subtitle: tp('ErrorFeedback', 'Our team has been notified.'),
            subtitle2: tp('ErrorFeedback', 'If you’d like to help, tell us what happened below.'),
            labelName: tp('ErrorFeedback', 'Name'),
            labelEmail: tp('ErrorFeedback', 'Email'),
            labelComments: tp('ErrorFeedback', 'What happened?'),
            labelClose: tp('ErrorFeedback', 'Close'),
            labelSubmit: tp('ErrorFeedback', 'Submit'),
            errorGeneric: tp('ErrorFeedback', 'An unknown error occurred while submitting your report. Please try again.'),
            errorFormEntry: tp('ErrorFeedback', 'Some fields were invalid. Please correct the errors and try again.'),
            successMessage: tp('ErrorFeedback', 'Your feedback has been sent. Thank you!'),
        });
    }, []);
    return (React.createElement(Spectrum, null,
        React.createElement(Flex, { UNSAFE_className: "annotely", flex: "1", width: "100%", height: "100%", maxHeight: "100%", direction: "column", UNSAFE_style: { overflow: 'hidden' } },
            React.createElement(View, { backgroundColor: "gray-50", borderBottomWidth: "thick", borderBottomColor: "gray-200" },
                React.createElement(Flex, { position: "relative", direction: "row", alignItems: "center", height: "100%" },
                    React.createElement(Flex, { direction: "row", marginX: "size-200", UNSAFE_className: "slogo", alignItems: "center" },
                        React.createElement(LogoInHTML, null),
                        React.createElement("span", null, "Annotely")))),
            React.createElement(Flex, { flex: "1", alignItems: "center", justifyContent: "center", gap: "size-400" },
                React.createElement(Flex, { gap: "size-200", direction: "column", alignItems: "center" },
                    React.createElement(Flex, { direction: "column", gap: "size-400" },
                        React.createElement(View, null, tp('crashPage', 'Application error has occurred')),
                        React.createElement(View, { maxWidth: "size-6000" }, tp('crashPage', 'An error occurred while creating the project, that required restarting the editor.'))),
                    React.createElement(Flex, { direction: "row", gap: "size-200" },
                        React.createElement(ActionButton, { onPress: onReport }, tp('crashPage', 'Report feedback')),
                        React.createElement(ActionButton, { onPress: refreshPage }, tp('crashPage', 'Refresh app'))))))));
};
export default Crash;
